import { defineStore } from 'pinia'
import { ref } from 'vue'
import { toast } from '../mixins/dialogMixin'

export const useProjectComents = defineStore('projectComments', () => {
  const comments = ref([])
  const currentProjectId = ref(null)
  const currentPhaseId = ref(undefined)
  const currentRuleId = ref(undefined)
  const currentObjectId = ref(undefined)
  const page = ref(0)
  const filter = ref([])

  const load = async (targetProjectId, phaseId, ruleId, objectId) => {
    currentProjectId.value = targetProjectId
    currentPhaseId.value = phaseId
    currentRuleId.value = ruleId
    currentObjectId.value = objectId
    try {
      const response = await axios.get(route('api.comment.index', {
        project_id: currentProjectId.value,
        phase_id: currentPhaseId.value,
        rule_id: currentRuleId.value,
        object_id: currentObjectId.value,
        page: page.value,
        filter: filter.value,
      }))
      comments.value = response.data
    } catch (e) {
      console.error(e)
      toast('error', 'Berichten kunnen niet geladen worden')
    }
  }

  const reload = async () => {
    if (!currentProjectId.value) {
      throw Error('No project loaded')
    }
    load(currentProjectId.value, currentPhaseId.value, currentRuleId.value, currentObjectId.value)
  }

  const setPage = (pageNumber) => {
    if (page.value === pageNumber) {
      return
    }
    page.value = pageNumber
    reload()
  }

  const setFilter = (filterArray) => {
    page.value = 0
    filter.value = filterArray
    reload()
  }

  return {
    load,
    reload,
    comments,
    filter,
    setPage,
    setFilter,
  }
})
